import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react/dist/iconify.js";
import moment from "moment";
import "./style.css";
import { Block } from "@/components/crRender";
import UserWritingSection from "./components/UserWritingSection";
import ChatContent from "./components/ChatContent";

export interface Message {
    id: number;
    message: string;
    isMine: boolean;
    attachmentsPath: string;
    date: string;
}

interface ChatWidgetProps {
    providerOrderId: string | number;
    sendMessageAPI: (id :number, body: any) => Promise<any>;
    getMessagesAPI: (id :number) => Promise<any>;
    className?: string;
    setIsChatOpen: (isChatOpen: boolean) => void;
    isChatOpen: boolean;
}

const ChatWidget: React.FC<ChatWidgetProps> = ({
    providerOrderId,
    sendMessageAPI,
    getMessagesAPI,
    className = "",
    setIsChatOpen,
    isChatOpen
}) => {
    const { t } = useTranslation();
    const [messages, setMessages] = useState<Message[]>([]);
    return (
        <Block isRender={isChatOpen} className={`chat-widget ${className}`}>
            {/* Chat Header */}
            <div className="chat-header">
                <div className="chat-header-content">
                    <Icon icon="mdi:message-text" width={24} />
                    <div className="chat-header-text">
                        <h3>{t("Conversation")}</h3>
                        <p>{t("Chat with your patient")}</p>
                    </div>
                </div>
                <div className="chat-close-btn"> <Icon icon="mdi:close" width={24} onClick={() => setIsChatOpen(false)} /></div>
            </div>

            <div className="chat-messages">
                <ChatContent getMessagesAPI={getMessagesAPI} providerOrderId={providerOrderId} messages={messages} setMessages={setMessages} />
            </div>
            <UserWritingSection sendAPI={sendMessageAPI} providerOrderId={providerOrderId} setMessages={setMessages} />
        </Block>
    );
};

export default ChatWidget;
